module.exports = __webpack_public_path__ + "static/media/14quantri.92a559c2.jpg";